// Chart 2 & 3: 시나리오 비교 막대 — port of make_compare_bar()
// unit: 'manwon'(만원, default) | 'eokwon'(억원)
import usePlotly from './usePlotly';
import { toManwon, toEokwon } from '../../lib/format';

export default function BarChart({ labels, values, title, yTitle, unit = 'manwon' }) {
  const ref = usePlotly(() => {
    const isEok = unit === 'eokwon';
    const converted = isEok ? toEokwon(values) : toManwon(values);
    const suffix    = isEok ? '억' : '만';
    const fmt       = isEok ? '.1f' : '.0f';

    return {
      data: [{
        type: 'bar',
        x: labels,
        y: converted,
        marker: { color: ['#9a6338', '#c8874a'] },
        text: converted.map(v => v.toFixed(isEok ? 1 : 0) + suffix),
        textposition: 'outside',
      }],
      layout: {
        title: { text: title, font: { size: 13 } },
        height: 380,
        yaxis: {
          title: yTitle,
          ticksuffix: suffix,
          tickformat: fmt,
          gridcolor: '#ead9c7',
        },
        xaxis: { gridcolor: '#ead9c7' },
      },
    };
  }, [labels, values, title, yTitle, unit]);

  return <div ref={ref} style={{ width: '100%' }} />;
}
